import { useQuery } from '@tanstack/react-query';
import { TimesheetAdditionalConfigurationRaw } from './types'
import { QUERY_KEY_SETTINGS_TIMESHEET_ADDITIONAL, SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'
import { getTimesheetAdditionalSettings } from './getTimesheetAdditionalSettings';

/**
 * Fetches basic timesheet company settings.
 */
export function useQueryTimesheetAdditionalSettings(companyId: string) {
  return useQuery<TimesheetAdditionalConfigurationRaw>({
    queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_ADDITIONAL, companyId],
    queryFn: async () => {
      const { data } = await getTimesheetAdditionalSettings({ companyId })
      return data //parseTimesheetAdditionalSettings(data);
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  });
}
